// Internal Module Imports
import { BASE_URL_BIDDING_SERVICE } from '../../../constants';
import { HttpClient } from '../../../utils/httpClient';

const PATH = {
    get: `/${BASE_URL_BIDDING_SERVICE}/admin/instance-bundle`,
    create: `/${BASE_URL_BIDDING_SERVICE}/admin/instance-bundle`,
    update: `/${BASE_URL_BIDDING_SERVICE}/admin/instance-bundle`,
    delete: `/${BASE_URL_BIDDING_SERVICE}/admin/instance-bundle`,
    getBundleForSymetrical: `/${BASE_URL_BIDDING_SERVICE}/admin/instance-bundle/symetrical-bundle`,
};

const GetInstanceBundle = (params, start, callback, error, next) => {
    start();
    return HttpClient.get(`${PATH.get}`, { params }).then(callback).catch(error).finally(next);
};

const CreateInstanceBundle = (payload, start, callback, error, next) => {
    start();
    return HttpClient.post(PATH.create, payload).then(callback).catch(error).finally(next);
};

const UpdateInstanceBundle = (id, payload, start, callback, error, next) => {
    start();
    return HttpClient.put(`${PATH.update}/${id}`, payload).then(callback).catch(error).finally(next);
};

const DeleteInstanceBundle = (id, start, callback, error, next) => {
    start();
    return HttpClient.delete(`${PATH.delete}/${id}`).then(callback).catch(error).finally(next);
};

const GetInstanceBundleForSymetricalBundle = (params, start, callback, error, next) => {
    start();
    return HttpClient.get(`${PATH.getBundleForSymetrical}`, { params }).then(callback).catch(error).finally(next);
};

export const AdminInstanceBundleService = {
    GetInstanceBundle,
    CreateInstanceBundle,
    UpdateInstanceBundle,
    DeleteInstanceBundle,
    GetInstanceBundleForSymetricalBundle,
};
